import { SelectOption } from './select.types';

export const uomOptions: SelectOption[] = [
    { label: 'EA (Each)', value: 'EA' },
    { label: 'GT (Gross Ton)', value: 'GT' },
    { label: 'NT (Net Ton)', value: 'NT' },
    { label: 'LB (Pound)', value: 'LB' },
];
